import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M440-440H225q-16 0-28-12t-11-28q0-17 11-28 12-12 28-12h215v-215q0-16 12-28t28-12q17 0 28 12 12 12 12 28v215h215q16 0 28 12t12 28q0 17-12 28-12 12-28 12H520v215q0 16-12 28t-28 11q-17 0-28-11-12-12-12-28v-215Z"/>',
  f: '<path d="M440-440H225q-16 0-28-12t-11-28q0-17 11-28 12-12 28-12h215v-215q0-16 12-28t28-12q17 0 28 12 12 12 12 28v215h215q16 0 28 12t12 28q0 17-12 28-12 12-28 12H520v215q0 16-12 28t-28 11q-17 0-28-11-12-12-12-28v-215Z"/>',
};

export default data;
